import { render, staticRenderFns } from "./OldMain.vue?vue&type=template&id=677ec74d&scoped=true&"
import script from "./OldMain.vue?vue&type=script&lang=js&"
export * from "./OldMain.vue?vue&type=script&lang=js&"
import style0 from "./OldMain.vue?vue&type=style&index=0&id=677ec74d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ec74d",
  null
  
)

export default component.exports